export const ui = {
  basename: "/",
};

export const api = {
  url: process.env.NODE_ENV === "production" ? "/" : "https://qa.zen.auto/",
  appSecret: "N4M*$Bt*xE$up0hIZIB+S2eY",
  isDebugEnabled: false,
};
